<template>
  <div class="index" :style="{'paddingTop': statusBar + 'rem'}">
    <Header :title="topicName" :back="true" left="首页" :white="true" />
    <van-form @submit="onSubmit">
      <van-field
        v-model="certName"
        name="用户名"
        label="用户名"
        placeholder="用户名"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        v-model="certNo"
        name="身份证号"
        label="身份证号"
        placeholder="身份证号"
        :rules="[{ required: true, message: '请填写密码' }]"
      />

      <p>认证方式：</p>
      <van-radio-group v-model="bizCode">
        <van-radio name="FACE_ALIPAY_SDK">FACE_ALIPAY_SDK</van-radio>
        <van-radio name="FACE_SDK">FACE_SDK</van-radio>
        <van-radio name="FACE">FACE</van-radio>
        <van-radio name="CERT_PHOTO_FACE">CERT_PHOTO_FACE</van-radio>
        <van-radio name="CERT_PHOTO">CERT_PHOTO</van-radio>
        <van-radio name="SMART_FACE">SMART_FACE</van-radio>
      </van-radio-group>

      <div style="margin: 16px;">
        <van-button type="primary" size="large" @click="fromSubmit()">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { Field, Button, Form, RadioGroup, Radio } from "vant";
export default {
  data() {
    return {
      certName: "",
      certNo: "",
      bizCode: "FACE_ALIPAY_SDK",
      statusBar: 0,
      value: "",
      topicName: "测试",
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
    window.resultAliFace = this.resultAliFace;
  },

  methods: {
    fromSubmit() {
      let keys = {
        certName: this.certName,
        certNo: this.certNo,
        bizCode: this.bizCode,
        certType: "IDENTITY_CARD",
        identityType: "CERT_INFO",
        returnUrl: "singlewindow://aliface?queryResult=true",
      };

      console.log(keys);

      this.$tool.callModule("requestAliFace", JSON.stringify(keys));
    },
    resultAliFace(val) {
      this.$router.push({
        name: "authenticationone",
        query: {
          retData: `${val.retData}`,
          certName: `${this.certName}`,
          certNo: `${this.certNo}`,
        },
      });
      console.log(val);
    },
  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
};
</script>

<style>
</style>